import { render, staticRenderFns } from "./Primitive.vue?vue&type=template&id=3740b46a&lang=pug&"
import script from "./Primitive.vue?vue&type=script&lang=js&"
export * from "./Primitive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports